import forOwn from 'lodash/forOwn';
import values from 'lodash/values';
import localityState from './locality-state';
var localityNamePattern = '[\\w-]+';
var statePattern = () => {
  var states = [];
  forOwn(localityState, value => {
    states.push(value.abbreviation);
  });
  return "(".concat(states.join('|').toLowerCase(), ")");
};
var postcodePattern = '\\d{1,4}';
export var LocalityTypeName;
(function (LocalityTypeName) {
  LocalityTypeName["DIVISION"] = "DIVISION";
  LocalityTypeName["DISTRICT"] = "DISTRICT";
  LocalityTypeName["REGION"] = "REGION";
  LocalityTypeName["STREET"] = "STREET";
  LocalityTypeName["POSTCODE"] = "POSTCODE";
  LocalityTypeName["SCHOOL"] = "SCHOOL";
})(LocalityTypeName || (LocalityTypeName = {}));
export var LocalityTypeKeys = Object.keys(LocalityTypeName);
var LocalityTypeValues = {
  DIVISION: {
    type: LocalityTypeName.DIVISION,
    name: LocalityTypeName.DIVISION,
    urlSlug: 'suburb',
    slugPattern: new RegExp("^(".concat(localityNamePattern, "-").concat(statePattern(), "-").concat(postcodePattern, ")$"), 'i'),
    shortSlugReplacement: '$1',
    idField: 'divisionId',
    idPrefix: 12
  },
  DISTRICT: {
    type: LocalityTypeName.DISTRICT,
    name: LocalityTypeName.DISTRICT,
    urlSlug: 'district',
    slugPattern: new RegExp("^(".concat(localityNamePattern, ")-district-(").concat(statePattern(), ")$"), 'i'),
    shortSlugReplacement: '$1-$2',
    idField: 'districtId',
    idPrefix: 11
  },
  REGION: {
    type: LocalityTypeName.REGION,
    name: LocalityTypeName.REGION,
    urlSlug: 'region',
    slugPattern: new RegExp("^(".concat(localityNamePattern, ")-region-(").concat(statePattern(), ")$"), 'i'),
    shortSlugReplacement: '$1-$2',
    idField: 'regionId',
    idPrefix: 10
  },
  STREET: {
    type: LocalityTypeName.STREET,
    name: LocalityTypeName.STREET,
    urlSlug: 'street'
  },
  POSTCODE: {
    type: LocalityTypeName.POSTCODE,
    name: LocalityTypeName.POSTCODE,
    urlSlug: 'postcode'
  },
  SCHOOL: {
    type: LocalityTypeName.SCHOOL,
    name: LocalityTypeName.SCHOOL,
    urlSlug: 'school'
  }
};
var LocalityType = LocalityTypeValues;
export var localityTypeByIdPrefix = idPrefix => idPrefix ? values(LocalityType).find(localityType => localityType.idPrefix === parseInt("".concat(idPrefix), 10)) : undefined;
export default LocalityType;